import React from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import SeverityTag from '../../components/SeverityTag';
import { formatShortMonthDate } from '../../helpers/date-utils';

import './GeneralIssueInfo.scss';

const GeneralIssueInfo = (props) => {
    const issue = props.selected?.general_issue || null;
    const detail = props.selected;

    if (issue?.recommendation) {
        return (
            <div className="general-issue-info">
                <h4 className="py-3 dark-grey">{issue.name}</h4>
                <Row className="mb-3">
                    <Col>
                        <div className="d-flex flex-column flex-fill justify-content-between align-items-start">
                            <h6 className="text-gray">First Date Found</h6>
                            <h6>{formatShortMonthDate(detail.entry_date, true)}</h6>
                        </div>
                    </Col>
                    <Col>
                        <div className="d-flex flex-column flex-fill justify-content-between align-items-start">
                            <h6 className="text-gray">Severity</h6>
                            <div id="severity-tooltip">
                                <SeverityTag value={issue.severity} />
                            </div>
                            
                            {issue.issue_background &&
                                <UncontrolledTooltip placement="bottom" target="severity-tooltip">
                                    { issue.issue_background }
                                </UncontrolledTooltip>
                            }                            
                        </div>
                    </Col>
                    <Col>
                        <div className="d-flex flex-column flex-fill justify-content-between align-items-start">
                            <h6 className="text-gray">Category</h6>
                            <h6>{issue.category}</h6>
                        </div>
                    </Col>
                </Row>
                {issue.impact && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Impact</h6>
                        </div>
                        <div className="description">{issue.impact}</div>
                    </div>
                )}
                {issue.description && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Description</h6>
                        </div>
                        <div className="description">{issue.description}</div>
                    </div>
                )}
                {issue.recommendation && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Recommendation</h6>
                        </div>
                        <div className="description">{issue.recommendation}</div>
                    </div>
                )}
                {issue.issue_background && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Issue Background</h6>
                        </div>
                        <div className="description">{issue.issue_background}</div>
                    </div>
                )}
                {issue.vector && issue.vector.search('undefined') === -1 && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>CVSS Attack Vector</h6>
                        </div>
                        <div className="description">{issue.vector}</div>
                    </div>
                )}
                {issue.score > 0 && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>CVSS Score</h6>
                        </div>
                        <div className="description">{issue.score}</div>
                    </div>
                )}
                {issue.references?.length > 0 && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>References</h6>
                        </div>
                        <div className="description">
                            {issue.references.map((reference, idx) => {
                                return (
                                    <div className="d-flex flex-fill flex-grow-1 justify-content-start" key={idx}>
                                        <a href={reference}>{reference}</a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                {issue.obligations && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Obligations</h6>
                        </div>
                        <div className="description">{issue.obligations}</div>
                    </div>
                )}
                {issue.restrictions && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Restrictions</h6>
                        </div>
                        <div className="description">{issue.restrictions}</div>
                    </div>
                )}
                {issue.valid_usages && (
                    <div className="detail-item">
                        <div className="title">
                            <h6>Valid usages</h6>
                        </div>
                        <div className="description">{issue.valid_usages}</div>
                    </div>
                )}
            </div>
        );
    }
    return null;
};

export default GeneralIssueInfo;
